import { useQuery } from "react-query";
import { fetchApi } from "helpers/reactQueryApi";

export function useFetchDeviceSettings(deviceId: string, options = {}) {
  return useQuery(
    ["deviceSettings", deviceId],
    () => fetchApi(`/api/v1/devices/${deviceId}/settings`),
    options,
  );
}
